import { render, staticRenderFns } from "./input-number-plus.vue?vue&type=template&id=2b4c8a5d"
import script from "./input-number-plus.vue?vue&type=script&lang=js"
export * from "./input-number-plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports